import { createRoutine, bindRoutineToReduxForm } from 'redux-saga-routines';
import { RETRIEVE_ME, UPDATE_ME } from './types';

export const retrieveMe = createRoutine(RETRIEVE_ME);
export const updateMe = createRoutine(UPDATE_ME);

export const bindedUpdateMe = bindRoutineToReduxForm(updateMe);
